import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteProject, PROJECTS_QUERY_KEYS } from '@/entities/project';
import { track } from '@/shared/analytics';

export { deleteProject };

interface UseDeleteProjectOptions {
  workspaceId?: string | null;
}

export function useDeletePublishedProject(options: UseDeleteProjectOptions = {}) {
  const queryClient = useQueryClient();
  const { workspaceId } = options;

  return useMutation({
    mutationFn: (projectId: string) => deleteProject(projectId),
    onSuccess: (_data, projectId) => {
      track('project_deleted', { project_id: projectId });
      queryClient.removeQueries({ queryKey: PROJECTS_QUERY_KEYS.detail(projectId) });
      void queryClient.invalidateQueries({ queryKey: ['projects', 'list'] });

      if (workspaceId) {
        void queryClient.invalidateQueries({ queryKey: ['projects', 'sidebar', workspaceId] });
        void queryClient.invalidateQueries({
          queryKey: PROJECTS_QUERY_KEYS.filterOptions(workspaceId),
        });
      }
    },
  });
}
